import Add from "@material-ui/icons/Add";
import React, { useEffect, useRef, useState } from "react";
import Fade from "react-reveal/Fade";
import KioskTypeForm from "../../components/KioskType/KioskTypeForm/KioskTypeForm";
import ViewKioskType from "../../components/KioskType/ViewKioskType/ViewKioskType";
import Button from "../../components/UI/Button/Button";
import Input from "../../components/UI/Input/Input";
import Modal from "../../components/UI/Modal/Modal";
import Search from "../../components/UI/Search/Search";
import Spinner from "../../components/UI/Spinner/Spinner";
import FetchData from "../../shared/fetchData";
import { updateObject } from "../../shared/utility";
import { toast } from "react-toastify";
import Table from "../../components/UI/Table/Table";

const KioskTypes = (props) => {
  const [loading, setLoading] = useState(false);
  const [rerender, setRerender] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [permission, setPermission] = useState(
    window.localStorage.getItem("permission")
  );
  const [kioskTypes, setKioskTypes] = useState([]);
  const [newKioskTypePage, setNewKioskTypePage] = useState(false);
  const [edit, setEdit] = useState(false);
  const [view, setView] = useState(false);
  const [lockerTypes, setLockerTypes] = useState([]);
  const [kioskType, setKioskType] = useState("");
  const [kioskTypeId, setKioskTypeId] = useState("");
  const [searchParams, setSearchParams] = useState({
    description: {
      elementType: "input",
      elementConfig: {
        type: "text",
        placeholder: "نام",
      },
      validation: {
        required: true,
      },
      errorMessage: "",
      valid: true,
      value: "",
    },
  });
  const childRef = useRef();

  useEffect(() => {
    setPageIndex(0);
    setPageSize(10);
    setPageCount(0);
    var raw = JSON.stringify({
      lockerType: {},
      pl: "1000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/lockertypes/getLockerTypes";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          setLockerTypes(result.lockerTypes);
        }
      })
      .catch((error) => setLoading(false));
  }, []);

  const inputChangedHandler = (event, controlName) => {
    const updatedControls = updateObject(searchParams, {
      [controlName]: updateObject(searchParams[controlName], {
        value: event.target.value,
      }),
    });
    setSearchParams(updatedControls);
  };
  const getData = (pagination, isRefresh) => {
    setPageIndex(pagination.pageIndex);
    setPageSize(pagination.pageSize);
    setLoading(true);
    var raw =
      !!isRefresh && isRefresh
        ? JSON.stringify({
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          })
        : JSON.stringify({
            kioskType: {
              description: searchParams.description.value,
            },
            pl: pagination.pageSize,
            pn: pagination.pageIndex + 1,
            version: "mtpx001",
          });
    var url = "management/api/v1/kiosktypes/getKioskTypes";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == 0) {
          let newList = [];
          for (let i = 0; i < pagination.pageIndex * pagination.pageSize; i++) {
            newList.push([]);
          }
          newList = newList.concat(result.kioskTypes);
          pushData(newList);
          setKioskTypes(newList);
          setPageCount(result.count);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => setLoading(false));
  };
  const pushData = (data) => {
    const rows = [];
    const headers = [
      {
        accessorKey: "description",
        header: "نام",
        align: "center",
      },
      {
        accessorKey: "generationDescription",
        header: "نسل لاکر",
        align: "center",
      },
      {
        accessorKey: "finalized",
        header: "وضعیت لاکر",
        align: "center",
      },
    ];
    const buttons = [];
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    data.map((d) => {
      rows.push({
        id: d.id,
        description: d.description,
        generationDescription: d.generationDescription,
        finalized:
          d.finalized != null && d.finalized == "1"
            ? "نهایی شده"
            : "نهایی نشده",
      });
    });
    buttons.push({ id: 1, text: "ویرایش", clicked: editKioskType });
    buttons.push({ id: 2, text: "مشاهده", clicked: viewKioskType });
    buttons.push({ id: 3, text: "نهایی سازی", clicked: kioskTypeFinalize });
    setTableData({ rows: rows, headers: headers, buttons: buttons });
    setRerender(!rerender);
  };
  const search = (event) => {
    getData({ pageIndex: pageIndex, pageSize: pageSize });
  };

  const refresh = (event) => {
    const srch = searchParams;
    for (let key in srch) {
      srch[key].value = "";
    }
    setSearchParams(srch);
    getData({ pageIndex: pageIndex, pageSize: pageSize }, true);
  };

  const toggleNewKioskForm = (event, value) => {
    if (value == false) {
      search();
    }
    setNewKioskTypePage(value);
  };

  const addNewKioskType = (event, id) => {
    setKioskType("");
    setEdit(false);
    toggleNewKioskForm(event, true);
  };

  const editKioskType = (id, data) => {
    const lckrTp = data.filter((l) => l.id == id);
    if (lckrTp != null && lckrTp.length != 0) {
      if (lckrTp[0].finalized === "1") {
        toast.error("رکورد مورد نظر نهایی است");
      } else {
        setKioskType(lckrTp[0]);
        setEdit(true);
        toggleNewKioskForm(null, true);
      }
    }
  };

  const viewKioskType = (id, data) => {
    const lckrTp = data.filter((l) => l.id == id);
    if (lckrTp != null && lckrTp.length != 0) {
      setKioskType(lckrTp[0]);
      setView(true);
    }
  };

  const toggleViewKioskForm = (event, value) => {
    setView(value);
  };

  const kioskTypeFinalize = (id, data) => {
    const lckrTp = data.filter((l) => l.id == id);
    if (lckrTp != null && lckrTp.length != 0) {
      if (lckrTp[0].finalized === "1") {
        toast.error("رکورد مورد نظر نهایی است");
      } else {
        setKioskTypeId(id);
        childRef.current.openModal();
      }
    }
  };
  const kioskTypeFinalizeSubmit = (event) => {
    var raw = JSON.stringify({
      kioskType: {
        id: kioskTypeId,
      },
      pl: "10000",
      pn: "1",
      version: "mtpx001",
    });
    var url = "management/api/v1/kiosktypes/kioskTypeFinalize";
    FetchData(raw, url)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.status == 0) {
          childRef.current.closeModal();
          search();
        }
      })
      .catch((error) => setLoading(false));
  };
  const afterCloseModal = (event) => {};
  const closeModal = (event, id) => {
    childRef.current.closeModal();
  };

  const formElementsArray = [];
  for (let key in searchParams) {
    formElementsArray.push({
      id: key,
      config: searchParams[key],
    });
  }

  let form = formElementsArray.map((formElement) => {
    return (
      <Input
        key={formElement.id}
        elementType={formElement.config.elementType}
        elementConfig={formElement.config.elementConfig}
        value={formElement.config.value}
        invalid={!formElement.config.valid}
        shouldValidate={formElement.config.validation}
        placeholder={formElement.config.placeholder}
        errorMessage={formElement.config.errorMessage}
        search={true}
        col="3 mt-2"
        changed={(event) => inputChangedHandler(event, formElement.id)}
      />
    );
  });
  form = (
    <div>
      <div className="row pl-4" dir="ltr" style={{ height: "0px" }}>
        <Button btnType="Refresh" clicked={refresh}></Button>
      </div>
      <div className="row mt-4">{form}</div>
      <div className="row text-left" dir="ltr">
        <div className="col-2">
          <Button btnType="search-btn" clicked={search}>
            جستجو
          </Button>
        </div>
      </div>
    </div>
  );

  const modalContent = (
    <div>
      <div className="row justify-content-center">
        آیا از نهایی کردن مطمئن هستید؟
      </div>
      <div className="row justify-content-center mt-3">
        <div className="col-6">
          <Button btnType="Success" clicked={kioskTypeFinalizeSubmit}>
            بله
          </Button>
        </div>
        <div className="col-6">
          <Button btnType="Success" clicked={closeModal}>
            خیر
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {loading ? <Spinner /> : ""}
      {!newKioskTypePage && !view ? (
        <Fade duration={200} left cascade>
          <div>
            <Search class="orders-search" form={form} />
            {permission != null && permission.includes("KIOSK_TYPE_WRITE") ? (
              <div className="row justify-content-center mt-3 ml-3">
                <div className="UserGeneralBtn mb-2">
                  <div
                    onClick={(event) => addNewKioskType(event)}
                    className="Add"
                  >
                    <Add className="UserIcon" />
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {rerender ? (
              // <Spinner />
              <Table
                hasDetails={false}
                data={kioskTypes}
                pageSize={pageSize}
                pageIndex={pageIndex}
                getData={getData}
                list={tableData}
                rowCount={pageCount}
                columnSize={170}
                loading={loading}
              />
            ) : (
              <Table
                hasDetails={false}
                data={kioskTypes}
                pageSize={pageSize}
                pageIndex={pageIndex}
                getData={getData}
                list={tableData}
                rowCount={pageCount}
                columnSize={170}
                loading={loading}
              />
            )}
          </div>
        </Fade>
      ) : (
        <div>
          {!view ? (
            <KioskTypeForm
              edit={edit}
              lockerTypes={lockerTypes}
              kioskType={edit ? kioskType : ""}
              toggleNewKioskForm={toggleNewKioskForm}
            />
          ) : (
            <ViewKioskType back={toggleViewKioskForm} kioskType={kioskType} />
          )}
        </div>
      )}
      <Modal
        content={modalContent}
        ref={childRef}
        closePermission="true"
        closeModal={(event) => afterCloseModal(event)}
      />
    </div>
  );
};

export default KioskTypes;
